<template>
  <v-container>
    <v-row>
      <v-col cols="12" >
        <v-img
          :src="require('@/assets/banner-finantare.png')"
          class="mx-auto"
          contain
          max-height="100px">
        </v-img>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <p class="text-center">
          CONȚINUTUL MATERIALELOR PUBLICATE PE ACEST SITE NU REPREZINTĂ ÎN MOD OBLIGATORIU POZIȚIA OFICIALĂ A UNIUNII EUROPENE SAU A GUVERNULUI ROMÂNIEI.
        </p>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" sm="6" offset-sm="3">
        <v-card>
          <v-card-title style="word-break: normal">
            <!-- <span>Înscriere în platformă</span> -->
            <!-- <v-alert type="info" border="left" prominent text class="text-justify">
              După ce creați contul, vă rugăm să așteptați validarea acestuia. În
              maxim 3 ore lucrătoare veți primi un SMS cu confirmarea validării contului, după care veți
              putea intra în contul nou creat.
            </v-alert> -->
          </v-card-title>
          <v-card-text>
            <v-alert color="info" v-if="aplicaFlag.disabled">
              {{ aplicaFlag.message }}
            </v-alert>

            <v-form v-model="validForm" ref="form">
              <v-text-field
                class="mt-2"
                persistent-hint
                v-model="lastName"
                label="Nume"
                hint="Numele dumneavoastră"
                required
                :rules="[rules.required]">
              </v-text-field>
              <v-text-field
                class="mt-2"
                persistent-hint
                v-model="firstName"
                label="Prenume"
                hint="Prenumele dumneavoastră"
                required
                :rules="[rules.required]">
              </v-text-field>
              <v-text-field
                class="mt-2"
                persistent-hint
                v-model="email"
                label="E-mail"
                hint="E-mailul dumneavoastră"
                required
                :rules="[rules.required, rules.email]">
              </v-text-field>
              <v-text-field
                class="mt-2"
                persistent-hint
                v-model="phone"
                label="Telefon"
                hint="Numărul dumneavoastră de telefon"
                required
                :rules="[rules.required]">
              </v-text-field>
              <v-text-field
                class="mt-2"
                persistent-hint
                :type="showPass ? 'text' : 'password'"
                v-model="password"
                label="Parolă"
                hint="Parola ce va fi asociată contului dumneavoastră"
                required
                :rules="[rules.required, rules.password, alike('checkPassword')]"
                :append-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="showPass = !showPass">
              </v-text-field>
              <v-text-field
                class="mt-2"
                persistent-hint
                :type="showPass ? 'text' : 'password'"
                v-model="checkPassword"
                label="Verificare parolă"
                hint="Reintroduceți parola pentru verificare"
                required
                :rules="[rules.required, rules.password, alike('password')]"
                :append-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="showPass = !showPass">
              </v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <!-- <v-btn color="primary" @click="signup" @dblclick="() => true" :loading="loading" :disabled="loading || aplicaFlag.disabled"> -->
            <v-btn color="primary" @click="signup" @dblclick="() => true" :loading="loading" :disabled="true">
              Creați cont
            </v-btn>
          </v-card-actions>
          <p class="caption px-4 text-h6">
            Aveți deja un cont?
            <router-link :to="{ name: 'Login' }">
              Autentificați-vă în platformă.
            </router-link>
          </p>
          <v-alert v-if="message" :type="message.type">{{ message.text }}</v-alert>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" >
        <v-img
          :src="require('@/assets/parteneri.png')"
          class="mx-auto"
          contain
          max-height="60px">
        </v-img>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import _debounce from 'lodash.debounce'

export default {
  name: 'SignupComponent',

  data: () => ({
    validForm: true,
    showPass: false,
    email: null,
    password: null,
    checkPassword: null,
    firstName: null,
    lastName: null,
    phone: null,
    message: null,
    loading: false,
    rules: {
      required: val => !!val || 'Campul nu poate fi gol!',
      email: value => {
        /* eslint-disable no-useless-escape */
        const re = new RegExp('[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?')
        return re.test(value) || 'Va rugam sa introduceti o adresa de email valida.'
      },
      password: value => {
        if (!value || !value.length) return true
        /* eslint-disable no-useless-escape */
        const re = new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})')
        return re.test(value) || 'Campul trebuie sa fie de minim 8 caractere lungime si sa contina: litere mici, litere mari, cifre si caractere speciale (!, @, #, $, %, ^, &)!'
      }
    }
  }),

  watch: {
    password () {
      this.validateForm()
    },
    checkPassword () {
      this.validateForm()
    }
  },

  computed: {
    startSignup () {
      return this.$store.getters.startSignup
    },
    endSignup () {
      return this.$store.getters.endSignup
    },

    aplicaFlag () {
      const now = new Date()
      if (this.startSignup) {
        const start = new Date(this.startSignup.date)
        if (this.endSignup) {
          const end = new Date(this.endSignup.date)

          if (start <= now && now <= end) {
            return {
              message: 'Aplica pana pe ' + end.toLocaleString('ro-RO', { year: 'numeric', month: 'long', day: 'numeric' }),
              disabled: false
            }
          }
          if (start < now && end < now) {
            return {
              message: 'Aplicatiile au fost inchise',
              disabled: true
            }
          }
          if (start > now) {
            return {
              message: `Aplica intre ${start.toLocaleString('ro-RO', { year: 'numeric', month: 'long', day: 'numeric' })} si ${end.toLocaleString('ro-RO', { year: 'numeric', month: 'long', day: 'numeric' })}`,
              disabled: true
            }
          }
        } else {
          if (start <= now) {
            return {
              message: 'Aplica acum',
              disabled: false
            }
          }
          if (start > now) {
            return {
              message: 'APlica dupa ' + start.toLocaleString('ro-RO', { year: 'numeric', month: 'long', day: 'numeric' }),
              disabled: true
            }
          }
        }
      } else {
        if (this.endSignup) {
          const end = new Date(this.endSignup)

          if (end <= now) {
            return {
              message: 'Aplicatiile au fost inchise',
              disabled: true
            }
          }
          if (end >= now) {
            return {
              message: 'Aplica pana pe ' + end.toLocaleString('ro-RO', { year: 'numeric', month: 'long', day: 'numeric' }),
              disabled: false
            }
          }
        } else {
          return {
            message: 'Aplica acum',
            disabled: false
          }
        }
      }
      return {
        message: 'Aplica acum',
        disabled: false
      }
    }
  },

  methods: {
    alike (ref) {
      return value => {
        return this[ref] === value || 'Parolele trebuie sa coincida.'
      }
    },
    signup: _debounce(async function () {
      /* eslint-disable no-unreachable */
      return
      this.message = {}
      const valid = this.$refs.form.validate()
      if (valid) {
        this.loading = true

        await this.$recaptchaLoaded()

        const token = await this.$recaptcha('signup')

        const result = await this.$store.dispatch('signup', {
          token,
          email: this.email.trim(),
          firstName: this.firstName,
          lastName: this.lastName,
          phone: this.phone,
          role: 'aplicant',
          approved: true,
          password: this.password.trim(),
          details: {
            email: this.email.trim(),
            firstName: this.firstName,
            lastName: this.lastName,
            phone: this.phone
          }
        })

        this.loading = false

        if (result === true) {
          this.message = {
            type: 'info',
            text: 'Contul a fost creat.'
          }
        } else {
          if (result.message === 'Where the recaptcha token, bro? ;)') {
            this.message = {
              type: 'error',
              text: 'Validare esuata, va rugam sa reincarcati pagina si sa incercati din nou.'
            }
          } else if (result.message === 'Mr. Robot?') {
            this.message = {
              type: 'error',
              text: 'Validare esuata, va rugam sa reincarcati pagina si sa incercati din nou.'
            }
          } else {
            this.message = {
              type: 'error',
              text: result.name === 'Conflict' ? 'Această adresa de email a fost deja folosită.' : 'Ne cerem scuze, a apărut o eroare la crearea contului dumneavoastră...'
            }
          }
        }
      }
    }, 500),
    validateForm: _debounce(function () {
      this.$refs.form.validate()
    }, 500)
  }
}
</script>
